import React from 'react';
import {FormControl, InputLabel, MenuItem, Select} from '@mui/material';

const WORLDS = [
    {value: 'ecexplore', label: 'Explore'},
    {value: 'ecplotgrid', label: 'Plot World (Grid)'},
    {value: 'ecplotnatural', label: 'Plot World (Natural)'},
    {value: 'ecpresetbuild', label: 'Preset Builds'},
    {value: 'ecevent', label: 'Events'},
    {value: 'ecbuilding', label: 'Building'},
    {value: 'eclegacy', label: 'Legacy'},
    {value: 'ecold', label: 'Old'},
    {value: 'overworld', label: 'Overworld'},
    {value: 'nether', label: 'Nether'},
    {value: 'end', label: 'End'},
];

export const isWorldAllowed = (world, allowedWorlds) => !allowedWorlds?.length || allowedWorlds.includes(world);

export default function WorldSelectCombo({
                                             name,
                                             value,
                                             onChange,
                                             variant = 'outlined',
                                             small = false,
                                             disabled = false,
                                             allowedWorlds = []
                                         }) {
    return (
        <FormControl>
            <InputLabel id="world-select-label">World</InputLabel>
            <Select
                labelId="world-select-label"
                name={name}
                value={value}
                label="Dimension"
                size={small ? 'small' : 'medium'}
                variant={variant}
                onChange={onChange}
                disabled={disabled}
            >
                {WORLDS.filter(world => isWorldAllowed(world.value, allowedWorlds)).map(world =>
                    <MenuItem key={world.value} value={world.value}>{world.label}</MenuItem>)}
            </Select>
        </FormControl>
    );
}
